<script>
	import { ButtonGroup, Card, CardHeader, CardTitle, CardText, CardSubtitle, CardBody, Accordion, AccordionItem, Button } from '@sveltestrap/sveltestrap';

</script>

<main>
	<nav class="navbar sticky-top" style="background-color:#0D6EFD; padding:0px; height:70px ">
		<div class="container-fluid" style="align-items: left">
			<h2 class="navbar-brand" style="width:100%; text-align: left; color:white; font-size:1.6em">
				<img src="./logo_ffb.png" alt="" width="60" height="60" class="d-inline-block align-text-center">
				Applications FFBillard
			</h2>
			<!-- 	<img src="./logo_ffb.png" alt="logo" style="height:50px">
					<h2 style="width:100%; text-align: center; color:white" >
						Matchs de Carambole
					</h2> -->
			
		</div>
	</nav>
	

	<div class="center" style="padding:12px">
		<Card style="width:80%">
			<CardHeader style="background-color:lightyellow">
				<CardTitle>
					CARAMBOLE
					<br><img src="./miniature-carambole.jpg" class="" alt="...">
				</CardTitle>
			</CardHeader>
			<CardBody>
				<Card>
					<CardHeader style="background-color:lightblue">
						<CardTitle>MATCHS</CardTitle>
					</CardHeader>
					<CardBody>
						<CardSubtitle>Affichage de tous les matchs d'un joueur</CardSubtitle>
						<br>

						<a href="https://apps.ffbillard.com/carambole_matchs" target="_blank">
							<div>
							<img  src="./app.jpg" class="card-img-top mb-3 w-auto" alt="...">
							</div>
						</a>
						<br>
						<br>
						<CardText style="text-align: left;">Il suffit de renseigner le N° de licence (les chiffres et la lettre ) puis cliquer sur le bouton <i class="bi bi-search"></i> à droite. L'application 
										affichera alors les informations relatives à ce joueur.
										<br>
										Si on ne connaît pas le numéro de licence on peut écrire dans le champs de texte suivant les premières lettres du nom du joueur (au moins 3) puis cliquer sur le bouton <i class="bi bi-search"></i> à droite. L'application 
										affichera alors une liste des joueurs dont le nom commence par les lettres choisis. En cliquant sur le nom voulu on obtient les informations relatives à ce joueur.
									</CardText>
					
						<a href="https://apps.ffbillard.com/carambole_matchs" target="_blank" class="card-link">Ouvrir l'application</a>			
					</CardBody> 
				</Card>	
			</CardBody> 
		</Card>	
	</div>

	
</main>

<style>
	.center {
		text-align: center;
    display: flex;
    /* //flex-flow: column; */
    justify-content: center;
	}


</style>